(function () {
  'use strict';

  var locale = 'tr-TR';

  function format(cents, currency) {
    var value = Number(cents);
    var code = String(currency || 'TRY').toUpperCase();
    if (!Number.isFinite(value)) return '';

    try {
      var formatted = new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value / 100);
      return formatted + ' ' + (code === 'TRY' ? 'TL' : code);
    } catch (error) {
      return (value / 100).toFixed(2) + ' ' + code;
    }
  }

  window.SeckinMoney = { format: format };

  if (!window.customElements.get('seckin-money')) {
    window.customElements.define('seckin-money', class extends HTMLElement {
      connectedCallback() {
        var formatted = format(this.dataset.cents, this.dataset.currency);
        if (formatted) this.textContent = formatted;
      }
    });
  }
})();
